const wyrdContactUrl = 'https://www.wyrd-games.net/contact-us';
const wyrdOldContactPattern =
  /^(?:https?:\/\/(?:www\.)?wyrd-games\.net)?\/contact\/?(?:[?#].*)?$/i;

document
  .querySelectorAll('.shopify-policy__body a[href]')
  .forEach((link) => {
    const rawHref = link.getAttribute('href')?.trim() || '';
    const absoluteHref = link.href;

    if (
      !wyrdOldContactPattern.test(rawHref) &&
      !wyrdOldContactPattern.test(absoluteHref)
    ) {
      return;
    }

    link.href = wyrdContactUrl;

    const visibleText = link.textContent?.trim() || '';
    if (
      visibleText === rawHref ||
      wyrdOldContactPattern.test(visibleText)
    ) {
      link.textContent = wyrdContactUrl;
    }
  });
